import { render, staticRenderFns } from "./ManageForm8.vue?vue&type=template&id=7fb8e4ba&"
import script from "./ManageForm8.vue?vue&type=script&lang=js&"
export * from "./ManageForm8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports